import React, { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import PrimaryButton from '../../../components/Buttons/PrimaryButton';
import {
  Container,
  Header,
  MainContent,
  NavigationMenu,
  Title,
  TitleWrapper,
  WrapperMainContent,
} from './styles';
import {
  BlogIcon,
  CardPlusIcon,
  ChallengeIcon,
} from '../../../assets/svg/SVGComponents';
import FeedChallenge from '../FeedChallenge';
import SectionTutorialButton from '../../../components/Onboarding/SectionTutorialButton';
import { TutorialId } from '../../../hooks/onboarding';

const ChallengePage: React.FC = () => {
  const [selectedTab, setSelectedTab] = React.useState(0);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (isTabletOrMobile || isPortrait) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [isPortrait, isTabletOrMobile]);

  const handleSelectedTabChange = useCallback((_event, tabIndex) => {
    setSelectedTab(tabIndex);
  }, []);
  return (
    <Container>
      <MainContent>
        <Header>
          <TitleWrapper>
            <ChallengeIcon
              width="1.9rem"
              strokeWidth={2}
              strokeStarColor="#ff9800"
              fillLeafColor="#ff9800"
            />
            <h1>Desafios</h1>
            <SectionTutorialButton tutorialId={TutorialId.CHALLENGES} />
          </TitleWrapper>
        </Header>

        <WrapperMainContent>
          <NavigationMenu>
            <Title>
              <h1>Desafios disponíveis</h1>
            </Title>
            <FeedChallenge tag="available" />
            <Title>
              <h1>Desafios enviados</h1>
            </Title>
            <FeedChallenge tag="user" />
          </NavigationMenu>
        </WrapperMainContent>
      </MainContent>
    </Container>
  );
};

export default ChallengePage;
